// Бага ангийн хүүхэд (эцэг эх) — v0.1 дизайны "Хүүхэд" таб: Оролцооны үйл явц (MIAP радар, хэмжээс бүрийн дундаж ба өөрчлөлт),
// багшийн 7 хоногийн ажиглалт, хүүхдийн хэлсэн үг, тухайн 7 хоногийн агшин (зураг/бичлэг); children — дундуур (хичээлийн үнэлгээ), доор нь жижиг ирц.
// Зөвхөн багшийн нийтэлсэн 7 хоногийн тайлан харагдана. /student/elem/:id
import React, { useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import { Link } from "react-router-dom";
import { FiChevronLeft, FiChevronRight, FiPlay } from "react-icons/fi";
import { instance } from "utils/axios";
import { SectionHead } from "./ParentDashboard";

const API = (process.env.REACT_APP_MAIN_API_URL || "").replace(/\/$/, "");
const src = (p) => (p ? `${API}${p}` : null);
const md = (d) => (d ? `${Number(d.slice(5, 7))}/${Number(d.slice(8, 10))}` : "");
const DAY = ["Ням", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба"];
const dayName = (d) => DAY[new Date(`${d}T00:00:00Z`).getUTCDay()];

const MIAP = {
  M: ["Motivation", "Хүсэл, сонирхол, идэвх"],
  I: ["Identity", "Өөрийгөө илэрхийлэх, хамаарах мэдрэмж"],
  A: ["Agency", "Санаачилга, сонголт, өөрийгөө удирдах"],
  P: ["Purpose", "Утга, ач холбогдлыг ойлгох"],
};
// Сурлагын тайлан — өдөр бүрийн хүрсэн түвшин
const LEARN = [["Ойлгосон байна", "гол агуулгыг мэдэж, өөрийн үгээр тайлбарлана"], ["Хэрэглэж байна", "даалгавар, бодит нөхцөлд хэрэглэж, задлан шинжилнэ"], ["Эзэмшсэн байна", "бие даан хийж, үнэлэлт хийн шинэ шийдэл гаргана"]];
const LEVEL = ["Хангалттай ажиглагдаагүй", "Багшийн дэмжлэгтэйгээр", "Зарим үед өөрөө", "Өөрийн санаачилгаар", "Тогтвортой, тодорхой"];

// Радар: M дээр, I баруун, A доор, P зүүн; 1–4
function Radar({ avg, prev }) {
  const R = 84, C = 110;
  const axes = [["M", 0, -1], ["I", 1, 0], ["A", 0, 1], ["P", -1, 0]];
  const pt = (v, dx, dy) => [C + dx * R * ((v || 0) / 4), C + dy * R * ((v || 0) / 4)];
  const poly = (vals) => axes.map(([k, dx, dy]) => pt(vals[k], dx, dy).join(",")).join(" ");
  const hasPrev = Object.values(prev || {}).some((v) => v != null);
  return (
    <figure className="m-0 flex flex-col items-center gap-2 shrink-0">
      <svg viewBox="0 0 220 220" width="210" height="210" role="img" aria-label={`MIAP: ${axes.map(([k]) => `${k} ${avg[k] ?? "—"}`).join(", ")}`}>
        {[1, 2, 3, 4].map((l) => <polygon key={l} points={axes.map(([, dx, dy]) => pt(l, dx, dy).join(",")).join(" ")} fill={l === 4 ? "#faf7ff" : "none"} stroke="#e5d8f5" strokeWidth="1" />)}
        {axes.map(([k, dx, dy]) => <line key={k} x1={C} y1={C} x2={C + dx * R} y2={C + dy * R} stroke="#e5d8f5" />)}
        {hasPrev && <polygon points={poly(prev)} fill="none" stroke="#0e7490" strokeWidth="2" strokeDasharray="4 3" />}
        <polygon points={poly(avg)} fill="rgba(92,16,144,.16)" stroke="#5c1090" strokeWidth="2" />
        {axes.map(([k, dx, dy]) => <circle key={k} cx={pt(avg[k], dx, dy)[0]} cy={pt(avg[k], dx, dy)[1]} r="3.5" fill="#5c1090" stroke="#fff" strokeWidth="2" />)}
        {axes.map(([k, dx, dy]) => <text key={`t${k}`} x={C + dx * (R + 15)} y={C + dy * (R + 15) + 5} textAnchor="middle" fontSize="14" fontWeight="800" fill="#3d1b6e">{k}</text>)}
      </svg>
      <figcaption className="flex gap-4 text-xs text-[#6e5e8a]">
        <span className="flex items-center gap-1.5"><span className="inline-block w-4 h-0.5 bg-[#5c1090]" />Энэ 7 хоног</span>
        {hasPrev && <span className="flex items-center gap-1.5"><span className="inline-block w-4 border-t-2 border-dashed border-[#0e7490]" />Өмнөх 7 хоног</span>}
      </figcaption>
    </figure>
  );
}

function Media({ items }) {
  const [open, setOpen] = useState(null);
  if (!items.length) return <p className="m-0 text-sm text-[#6e5e8a]">Энэ 7 хоногт зураг, бичлэг алга.</p>;
  return (
    <>
      <div className="grid gap-3 grid-cols-2 md:grid-cols-4">
        {items.map((m) => (
          <button key={m.id} type="button" onClick={() => setOpen(m)} className="text-left flex flex-col gap-1.5 group">
            <span className="relative block w-full aspect-[4/3] rounded-[14px] overflow-hidden bg-[#f3eeff]">
              {m.thumb && <img src={src(m.thumb)} alt={m.caption || ""} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform" />}
              {m.kind === "video" && <span className="absolute inset-0 flex items-center justify-center"><span className="h-11 w-11 rounded-full bg-black/55 text-white flex items-center justify-center"><FiPlay size={20} /></span></span>}
            </span>
            <span className="text-[13px] leading-snug"><b className="text-primary">{dayName(m.date)}</b>{m.caption ? ` · ${m.caption}` : ""}</span>
          </button>
        ))}
      </div>
      <Modal open={!!open} onCancel={() => setOpen(null)} footer={null} width={900} centered destroyOnClose title={open ? `${dayName(open.date)} · ${md(open.date)}` : ""}>
        {open && (open.kind === "video"
          ? <video src={src(open.url)} controls playsInline autoPlay className="w-full max-h-[75vh] rounded-xl bg-black" />
          : <img src={src(open.url)} alt={open.caption || ""} className="w-full max-h-[75vh] object-contain rounded-xl" />)}
        {open?.caption && <p className="mt-3 mb-0 text-sm">{open.caption}</p>}
      </Modal>
    </>
  );
}

export default function ElemChild({ child, children }) {
  const [week, setWeek] = useState(null);
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { setWeek(null); }, [child.id]);
  useEffect(() => {
    let alive = true;
    setErr(null);
    instance({ method: "get", url: `/student/elem/${child.id}`, params: week ? { week } : {} })
      .then((r) => { if (alive) setD(r.data); })
      .catch((e) => { if (alive) setErr(e?.response?.data?.error || "Мэдээлэл татаж чадсангүй"); });
    return () => { alive = false; };
  }, [child.id, week]);

  if (err) return <section className="tj-card p-6 text-sm text-[#6e5e8a]">{err}</section>;
  if (!d || d.student?.id !== child.id) return <div className="flex justify-center py-10"><Spin /></div>;
  const r = d.report;
  const i = r ? d.weeks.indexOf(r.weekStart) : -1;
  const a = d.attendance;
  const navBtn = "h-9 w-9 rounded-full border border-[#e9e8f0] bg-white flex items-center justify-center text-[#6e5e8a] hover:bg-[#faf7ff] disabled:text-[#e5d8f5] disabled:hover:bg-white";

  return (
    <div className="flex flex-col gap-3.5 md:gap-5">
      {/* Ангийн 7 хоног — ерөнхий хэсэг (бүх эцэг эхэд ижил) */}
      {r?.classPart && (
        <section aria-labelledby="cls-h" className="tj-card px-4 pt-[18px] pb-5 md:p-6 flex flex-col gap-3">
          <SectionHead eyebrow="7 хоногийн тайлан" title={<span id="cls-h">Ангийн 7 хоног</span>} sub={`${md(r.weekStart)} – ${md(r.weekEnd)}`} />
          {r.classPart.projects.length > 0 && (
            <div className="flex flex-wrap gap-2">{r.classPart.projects.map((p) => <span key={p.id} className="rounded-full bg-[#f3eeff] text-primary text-[13px] font-bold px-3 py-1">Төсөл: {p.name}</span>)}</div>
          )}
          {r.classPart.summary && <p className="m-0 text-[15px] leading-relaxed whitespace-pre-line">{r.classPart.summary}</p>}
          {r.classPart.days.length > 0 && (
            <ul className="m-0 pl-0 list-none flex flex-col gap-1.5">
              {r.classPart.days.map((x) => (
                <li key={x.date} className="text-sm"><b className="text-primary">{dayName(x.date)}</b> — {x.title}{x.summary ? <span className="text-[#6e5e8a]"> · {x.summary}</span> : null}</li>
              ))}
            </ul>
          )}
          {r.classPart.media.length > 0 && <Media items={r.classPart.media} />}
        </section>
      )}
      {/* Оролцооны үйл явц */}
      <section aria-labelledby="miap-h" className="tj-card px-4 pt-[18px] pb-5 md:p-6">
        <SectionHead eyebrow="7 хоногийн тайлан" title={<span id="miap-h">Оролцооны үйл явц (MIAP)</span>}
          sub={r ? `${md(r.weekStart)} – ${md(r.weekEnd)}` : null}
          right={d.weeks.length > 1 && r ? (
            <div className="flex items-center gap-1 shrink-0">
              <button aria-label="Өмнөх тайлан" className={navBtn} disabled={i >= d.weeks.length - 1} onClick={() => setWeek(d.weeks[i + 1])}><FiChevronLeft /></button>
              <button aria-label="Дараагийн тайлан" className={navBtn} disabled={i <= 0} onClick={() => setWeek(d.weeks[i - 1])}><FiChevronRight /></button>
            </div>
          ) : null} />
        {!r ? (
          <p className="mt-3 mb-0 text-sm text-[#6e5e8a]">Багш 7 хоногийн тайлангаа нийтлэхэд энд харагдана.</p>
        ) : (
          <>
            <div className="mt-3 flex flex-wrap gap-6 items-center">
              <Radar avg={r.avg} prev={r.prevAvg} />
              <ul className="list-none m-0 p-0 flex flex-col gap-3.5 flex-1 min-w-[260px]">
                {Object.keys(MIAP).map((k) => {
                  const v = r.avg[k], p = r.prevAvg[k];
                  const diff = v != null && p != null ? Math.round((v - p) * 10) / 10 : null;
                  return (
                    <li key={k} className="flex items-center gap-3">
                      <span className="h-9 w-9 rounded-xl bg-primary text-white font-extrabold flex items-center justify-center shrink-0">{k}</span>
                      <span className="flex-1 min-w-0">
                        <span className="block text-[15px] font-bold">{MIAP[k][0]} <span className="font-normal text-[13px] text-[#6e5e8a]">{MIAP[k][1]}</span></span>
                        <span className="block h-2 rounded-full bg-[#f3eeff] overflow-hidden my-1"><span className="block h-full rounded-full bg-primary" style={{ width: `${((v || 0) / 4) * 100}%` }} /></span>
                        <span className="block text-xs text-[#6e5e8a]">{v == null ? "Ажиглагдаагүй" : LEVEL[Math.round(v)]}</span>
                        {r.evidence.filter((e) => e.dim === k).map((e, j) => <span key={j} className="block text-[13px] text-[#1c1c1c] leading-snug mt-1">“{e.text}”</span>)}
                      </span>
                      <span className="text-right w-12">
                        <span className="block text-xl font-extrabold tabular-nums">{v == null ? "—" : v.toFixed(1)}</span>
                        {diff != null && diff !== 0 && <span className={`block text-xs font-bold ${diff > 0 ? "text-[#166534]" : "text-[#b45309]"}`}>{diff > 0 ? "+" : ""}{diff.toFixed(1)}</span>}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
            <p className="mt-3 mb-0 text-xs text-[#6e5e8a]">1 Багшийн дэмжлэгтэйгээр · 2 Зарим үед өөрөө · 3 Өөрийн санаачилгаар · 4 Тогтвортой, тодорхой</p>
          </>
        )}
      </section>

      {r && (
        <div className="flex flex-wrap gap-3.5 md:gap-5 items-stretch">
          <section className="tj-card px-4 py-[18px] md:p-6 flex-[1.4_1_380px] min-w-0 flex flex-col gap-3">
            <h2 className="m-0 text-lg font-bold">Багшийн 7 хоногийн ажиглалт</h2>
            {[["noticed", "Юу шинээр анзаарав"], ["growth", "Хамгийн тод харагдсан өсөлт"], ["condition", "Хамгийн их идэвх гаргасан нөхцөл"], ["nextFocus", "Ирэх 7 хоногт анхаарах зүйл"]]
              .filter(([f]) => r[f]).map(([f, l]) => (
                <div key={f}><div className="text-[13px] font-bold text-primary">{l}</div><p className="m-0 text-[15px] leading-relaxed whitespace-pre-line">{r[f]}</p></div>
              ))}
            {!["noticed", "growth", "condition", "nextFocus"].some((f) => r[f]) && <p className="m-0 text-sm text-[#6e5e8a]">Энэ 7 хоногт ажиглалт бичээгүй.</p>}
          </section>
          <section className="rounded-[18px] md:rounded-[20px] border border-[#f2d675] bg-[#fff8db] px-4 py-[18px] md:p-6 flex-[1_1_300px] min-w-0 flex flex-col gap-3">
            <h2 className="m-0 text-xs font-extrabold tracking-[0.12em] uppercase text-[#7a5a00]">Хүүхдийн хэлсэн үг</h2>
            {r.childLiked && <div><div className="text-[13px] font-bold text-[#7a5a00]">Энэ 7 хоногт надад хамгийн их таалагдсан зүйл</div><p className="m-0 text-lg font-bold leading-snug">“{r.childLiked}”</p></div>}
            {r.childLearned && <div><div className="text-[13px] font-bold text-[#7a5a00]">Би өөрийнхөө тухай мэдсэн нэг зүйл</div><p className="m-0 text-lg font-bold leading-snug">“{r.childLearned}”</p></div>}
            {!r.childLiked && !r.childLearned && <p className="m-0 text-sm text-[#7a5a00]">Энэ 7 хоногт бичээгүй.</p>}
          </section>
        </div>
      )}

      {/* Сурлагын тайлан: 7 хоногийн зорилт, өдөр бүрийн түвшин (Ойлгосон · Хэрэглэж байна · Эзэмшсэн), хүүхдийн өөрийн дүгнэлт */}
      {r?.learning && (r.learning.goals || r.days.some((x) => x.level || x.note) || r.learning.selfBest || r.learning.selfHard) && (
        <section aria-labelledby="learn-h" className="tj-card px-4 pt-[18px] pb-5 md:p-6 flex flex-col gap-3">
          <SectionHead eyebrow="7 хоногийн тайлан" title={<span id="learn-h">Сурлагын тайлан</span>} sub={`${md(r.weekStart)} – ${md(r.weekEnd)} · ирц ${r.learning.present}/5`} />
          {r.learning.goals && (
            <div className="rounded-[14px] bg-[#f7f0ff] p-3.5">
              <div className="text-[11px] font-extrabold tracking-[0.12em] uppercase text-primary">Энэ 7 хоногийн зорилт</div>
              <p className="m-0 mt-1 text-[15px] leading-relaxed whitespace-pre-line">{r.learning.goals}</p>
            </div>
          )}
          <ul className="list-none m-0 p-0 flex flex-col">
            {r.days.map((x) => (
              <li key={x.date} className="flex gap-3 py-2.5 border-t border-[#efedf4] first:border-t-0">
                <span className="w-14 shrink-0"><b className="text-primary text-sm">{dayName(x.date)}</b><span className="block text-xs text-[#6e5e8a]">{md(x.date)}</span></span>
                <span className="flex-1 min-w-0">
                  <span className="block text-[15px] font-semibold">{x.title || <span className="text-[#b8a9d1] font-normal">—</span>}</span>
                  {x.summary && <span className="block text-[13px] text-[#6e5e8a]">{x.summary}</span>}
                  {x.note && <span className="block text-[13px] mt-1">Багш: {x.note}</span>}
                </span>
                <span className="flex gap-1 shrink-0 self-start" aria-label={x.level ? LEARN[x.level - 1][0] : "Тэмдэглээгүй"} title={x.level ? LEARN[x.level - 1][0] : ""}>
                  {LEARN.map(([l], j) => <span key={l} className={`h-6 w-6 rounded-md text-[11px] font-extrabold flex items-center justify-center ${x.level && j < x.level ? "bg-primary text-white" : "bg-[#f3eeff] text-[#b8a9d1]"}`}>{l[0]}</span>)}
                </span>
              </li>
            ))}
          </ul>
          <p className="m-0 text-xs text-[#6e5e8a]">{LEARN.map(([l, desc]) => <span key={l} className="mr-2"><b>{l[0]}</b> {l} · {desc}.</span>)}</p>
          {(r.learning.selfBest || r.learning.selfHard) && (
            <div className="rounded-[14px] border border-[#f2d675] bg-[#fff8db] p-3.5 flex flex-col gap-2">
              <div className="text-[11px] font-extrabold tracking-[0.12em] uppercase text-[#7a5a00]">Хүүхдийн өөрийн дүгнэлт</div>
              {r.learning.selfBest && <div><div className="text-[13px] font-bold text-[#7a5a00]">Энэ долоо хоногт миний хамгийн сайн сурсан зүйл</div><p className="m-0 text-base font-bold leading-snug">“{r.learning.selfBest}”</p></div>}
              {r.learning.selfHard && <div><div className="text-[13px] font-bold text-[#7a5a00]">Надад хүндрэлтэй байсан, дахиж сурмаар байгаа зүйл</div><p className="m-0 text-base font-bold leading-snug">“{r.learning.selfHard}”</p></div>}
            </div>
          )}
        </section>
      )}
      {r && (
        <section aria-labelledby="moments-h" className="tj-card px-4 py-[18px] md:p-6 flex flex-col gap-3">
          <SectionHead title={<span id="moments-h">Тухайн 7 хоногийн агшин</span>}
            sub={r.days.filter((x) => x.title).map((x) => `${dayName(x.date)}: ${x.title}`).join(" · ") || null} />
          <Media items={r.media} />
        </section>
      )}

      {children}

      {/* Ирц — жижиг */}
      <section className="tj-card px-4 py-4 md:px-6 flex flex-wrap items-center gap-x-6 gap-y-2">
        <span className="text-base font-bold">Ирц</span>
        <span className="text-sm text-[#6e5e8a]">Энэ улирал: <b className="text-[#1c1c1c] tabular-nums">{a.present}/{a.days}</b> өдөр ирсэн</span>
        <span className="text-sm text-[#6e5e8a]">Чөлөөтэй: <b className="text-[#1c1c1c]">{a.excused.length}</b>{a.excused.length ? ` (${a.excused.slice(-3).map((x) => md(x.date)).join(", ")})` : ""}</span>
        <span className="text-sm text-[#6e5e8a]">Хоцорсон: <b className="text-[#1c1c1c]">{a.late}</b></span>
        <Link to={`/school?c=${child.id}`} className="ml-auto text-sm font-bold text-primary">Чөлөө хүсэх</Link>
      </section>
    </div>
  );
}
